(function() {
  'use strict';
  
  // Traductions français
  const translations = {
    'Submit': 'Envoyer',
    'Required': 'Requis',
    'Email': 'E-mail',
    'Name': 'Nom',
    'Phone': 'Téléphone',
    'Message': 'Message',
    'First Name': 'Prénom',
    'Last Name': 'Nom de famille',
    'Address': 'Adresse',
    'City': 'Ville',
    'Country': 'Pays',
    'Please select': 'Veuillez sélectionner',
    'Please Select': 'Veuillez sélectionner',
    'Select': 'Sélectionner',
    'Choose an option': 'Choisir une option',
    'Please fill out this field': 'Veuillez remplir ce champ',
    'Please enter a valid email': 'Veuillez entrer un e-mail valide',
    'This field is required': 'Ce champ est requis',
    'Close': 'Fermer'
  };
  
  function translateHulkForm() {
    setTimeout(function() {
      // Traduire tous les éléments du formulaire
      document.querySelectorAll('[class*="hulk"], [id*="hulk"], form, select, option').forEach(function(element) {
        translateElement(element);
      });
      
      // Réparer les boutons de fermeture
      fixCloseButtons();
    }, 1000);
  }
  
  function translateElement(element) {
    // Traduire les labels, boutons, placeholders, options
    element.querySelectorAll('label, button, input, textarea, span, div, option, select').forEach(function(el) {
      // Texte
      if (el.textContent && translations[el.textContent.trim()]) {
        el.textContent = translations[el.textContent.trim()];
      }
      // Placeholder
      if (el.placeholder && translations[el.placeholder]) {
        el.placeholder = translations[el.placeholder];
      }
      // Value pour les options
      if (el.tagName === 'OPTION' && el.value && translations[el.value]) {
        el.textContent = translations[el.value];
      }
    });
  }
  
  // NOUVELLE FONCTION : Réparer les boutons de fermeture
  function fixCloseButtons() {
    const closeButtons = document.querySelectorAll(
      '.hulk-close, .hulk-modal-close, [data-dismiss="modal"], .close, button[onclick*="close"]'
    );
    
    closeButtons.forEach(function(btn) {
      // Supprimer les anciens événements
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      // Ajouter le nouvel événement
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeHulkModal();
      });
      
      // Forcer le style
      newBtn.style.cursor = 'pointer';
      newBtn.style.pointerEvents = 'auto';
      newBtn.style.zIndex = '99999';
    });
  }
  
  // NOUVELLE FONCTION : Fermer le modal Hulk
  function closeHulkModal() {
    // Trouver tous les modals ouverts
    const modals = document.querySelectorAll(
      '.hulk-modal, .hulk-form-modal, .modal, [role="dialog"], [class*="hulk"][style*="display: block"]'
    );
    
    modals.forEach(function(modal) {
      modal.style.display = 'none';
      modal.classList.remove('show', 'active', 'in', 'fade');
    });
    
    // Supprimer les backdrops
    const backdrops = document.querySelectorAll('.modal-backdrop, .hulk-backdrop, .fade');
    backdrops.forEach(function(backdrop) {
      backdrop.remove();
    });
    
    // Réactiver le scroll
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open', 'hulk-modal-open');
    
    console.log('Modal Hulk fermé');
  }
  
  // Rendre la fonction accessible globalement pour onclick
  window.closeHulkForm = closeHulkModal;
  
  // Exécuter au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateHulkForm);
  } else {
    translateHulkForm();
  }
  
  // Observer les changements dynamiques
  const observer = new MutationObserver(translateHulkForm);
  observer.observe(document.body, { childList: true, subtree: true });
})();
